import CommonDataProtection from '@/modules/common/hiring/models/MID/CommonDataProtection'
import ForeignHealthPolicyHolder from '../ForeignHealthPolicyHolder'

export default class ForeignHealthSavePolicyHolderRequest {
  /** (UUID): Identificador único de la cotización. Ejemplo: 23423-643hbf-74834hj. */
  quotationId!: string

  /** Información del titular de la póliza. */
  policyHolder!: ForeignHealthPolicyHolder

  /** Objeto que contiene información sobre protección de datos. */
  dataProtection!: CommonDataProtection

  constructor(data: any) {
    this.quotationId = data.quotationId

    if (data.policyHolder) {
      this.policyHolder = new ForeignHealthPolicyHolder(data.policyHolder)
    }

    if (data.dataProtection) {
      this.dataProtection = new CommonDataProtection(data.dataProtection)
    }
  }
}
